// Both Quick Find and the legacy Uncover flow save their modal under
// mode "discover", but they need opposite treatment when the user navigates
// back from a capsule.
//
// Uncover's restore genuinely depends on re-running openUncoverCluster: its
// capsules come from a live query and the saved markers are only a first paint.
// Quick Find's do not. Its capsules are written with `discoverOnly: true`, and
// mapCapsulesDataToMarker — which openUncoverCluster rebuilds through — filters
// exactly those out. So re-running it on a Quick Find restore replaced the
// restored list with an empty one, showed "you've discovered an empty spot" and
// closed the modal.
//
// The markers themselves carry the answer: handleQuickFind stamps
// quickFindCategoryKey on every row it opens, and nothing else does. Reading the
// saved markers rather than adding a flag at save time means entries already
// sitting in sessionStorage are handled too, instead of only ones saved from now
// on.
export function isQuickFindReturnState(returnState) {
  if (!returnState || typeof returnState !== "object") return false;
  if (String(returnState.mode || "").trim().toLowerCase() !== "discover") return false;

  const markers = Array.isArray(returnState.markers) ? returnState.markers : [];
  if (!markers.length) return false;

  // Every marker, not some: a mixed list means we cannot tell which flow saved
  // it, and guessing wrong either strands an Uncover restore or re-breaks this.
  return markers.every((marker) =>
    Boolean(String(marker?.quickFindCategoryKey || "").trim())
  );
}
